// ImageMagnifier.js
import { React,useState } from 'react';

const ImageMagnifier = ({
    src,
    className,
    alt,
    zoomLevel = 2,
}) => {
    const [showMagnifier, setShowMagnifier] = useState(false);
    const [[imgWidth, imgHeight], setSize] = useState([0, 0]);
    const [[x, y], setXY] = useState([0, 0]);

    const mouseEnter = (e) => {
        const el = e.currentTarget;
        const { width, height } = el.getBoundingClientRect();
        setSize([width, height]);
        setShowMagnifier(true);
    };

    const mouseLeave = () => {
        setShowMagnifier(false);
    };

    const mouseMove = (e) => {
        const el = e.currentTarget;
        const { top, left } = el.getBoundingClientRect();
        const x = e.pageX - left - window.scrollX;
        const y = e.pageY - top - window.scrollY;
        setXY([x, y]);
    };

    return (
        <div className="relative inline-block w-full h-full">
            <img
                src={src}
                alt={alt}
                onMouseEnter={mouseEnter}
                onMouseLeave={mouseLeave}
                onMouseMove={mouseMove}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                }}
                className={className}
            />
            {showMagnifier && (
                <div
                    style={{
                        position: 'absolute',
                        pointerEvents: 'none',
                        height: `${imgHeight}px`,
                        width: `${imgWidth}px`,
                        top: 0,
                        left: 0,
                        backgroundColor: 'white',
                        backgroundImage: `url('${src}')`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: `${imgWidth * zoomLevel}px ${imgHeight * zoomLevel}px`,
                        backgroundPositionX: `${-x * zoomLevel + imgWidth / 2}px`,
                        backgroundPositionY: `${-y * zoomLevel + imgHeight / 2}px`,
                        borderRadius: '5px',
                    }}
                />
            )}
        </div>
    );
};

export default ImageMagnifier;
